import FormDatePicker from '@views/components/Inputs/FormDatePicker';
import { Button, Col, Form, Row } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import Paper from '@/views/components/Paper/Paper';
import { INITIAL_TRAILER_DETAILS } from '@/views/pages/Savers/TrailerManagement/constants';

import { TAB_KEYS } from '../Quote/constants';

const OriginDetailsGrid = ({
  formTrailerRequestManagement,
  editMode,
  dropdownState,
  activeTabName,
  setPickupFormValues,
  setDeliveryFormValues,
  isMultiple,
}) => {
  const handleAddOrigin = (add) => {
    const formValues = formTrailerRequestManagement.getFieldsValue();
    const lastOrigin = formValues.orgLocations?.[formValues.orgLocations.length - 1];

    // biome-ignore lint/correctness/noUnusedVariables: removing origin ship location from origin Locations
    const { orgShipLocation, ...lastOriginWithoutShipLocation } = lastOrigin || {};

    const newOrigin = lastOrigin
      ? { ...lastOriginWithoutShipLocation }
      : { ...INITIAL_TRAILER_DETAILS.orgLocations[0] };

    add(newOrigin);
  };

  const handleFormChangeOrigin = (event, name) => {
    const { id, value, validity } = event.target;
    const isValidValue = validity.valid ? value : '';
    const val = isValidValue || '0';
    const parsedVal = Math.round(Number.parseInt(val, 10) / 23);

    const currentValues = formTrailerRequestManagement.getFieldsValue();

    if (currentValues.orgLocations && currentValues.orgLocations.length > 0) {
      const updatedOrgLocations = currentValues.orgLocations.map((entry) => {
        const updatedEntry = { ...entry };

        switch (id) {
          case 'orgtxtSoftWeight':
            updatedEntry.orgSoftWeight = val;
            updatedEntry.orgSoftOks = parsedVal;
            break;
          case 'orgtxtMiscWeight':
            updatedEntry.orgMiscWeight = val;
            updatedEntry.orgMiscOks = parsedVal;
            break;
          case 'orgtxtBookWeight':
            updatedEntry.orgBookWeight = val;
            updatedEntry.orgBookOks = parsedVal;
            break;
          default:
            updatedEntry[name] = val;
            break;
        }

        return updatedEntry;
      });

      formTrailerRequestManagement.setFieldsValue({
        orgLocations: updatedOrgLocations,
      });
    }
  };

  const removeFromList = (fieldName, indexToRemove) => {
    const currentValues = formTrailerRequestManagement.getFieldsValue();
    const updatedList = [...(currentValues[fieldName] || [])];
    updatedList.splice(indexToRemove, 1);

    formTrailerRequestManagement.setFieldsValue({
      [fieldName]: updatedList,
    });

    if (activeTabName === TAB_KEYS.PICKUP || !isMultiple) {
      setPickupFormValues((prev) => ({
        ...prev,
        [fieldName]: updatedList,
      }));
    } else {
      setDeliveryFormValues((prev) => ({
        ...prev,
        [fieldName]: updatedList,
      }));
    }
  };

  const handleDateForOrigin = (value, name) => {
    const currentValues = formTrailerRequestManagement.getFieldsValue();

    if (currentValues.orgLocations && currentValues.orgLocations.length > 0) {
      const updatedOrgLocations = currentValues.orgLocations.map((entry) => {
        const updatedEntry = { ...entry };
        updatedEntry[name] = value;
        return updatedEntry;
      });

      formTrailerRequestManagement.setFieldsValue({
        orgLocations: updatedOrgLocations,
      });
    }
  };

  return (
    <Col xs={48} sm={24}>
      <Paper className="mb-5">
        <Form.List name="orgLocations">
          {(fields, { add, remove }) => (
            <>
              <div className="card-header p-8">
                <Row gutter={10}>
                  <Col sm={18} className="d-flex align-items-center">
                    <span>Origin Details</span>
                  </Col>
                  <Col sm={6} className="text-right">
                    <Button onClick={() => handleAddOrigin(add)} size="small" type="default" icon={<PlusOutlined />}>
                      Add
                    </Button>
                  </Col>
                </Row>
              </div>
              <div className="card-body">
                <table className="w-100 origindetails">
                  <thead>
                    <tr>
                      <th className="background-header text-white fixed fixed-top shadow-none" width="150px">
                        Shipping Location
                      </th>
                      <th className="background-header text-white fixed fixed-top shadow-none" width="120px">
                        Spot Date
                      </th>
                      <th className="background-header text-white fixed fixed-top shadow-none trailer-request-management-fixed-width">
                        ETD
                      </th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Soft Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Soft OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Misc Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Misc OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Book Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Book OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Furn</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">OLI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields.map(({ key, name }) => (
                      <tr key={`${key}-${name}`}>
                        <td className="center-align">
                          <FormSelectBox
                            editMode={editMode}
                            name={[name, 'orgShipLocation']}
                            margin="m-0"
                            options={dropdownState.partnerLocationOptions}
                            loading={dropdownState.loading.partnerLocations}
                            placeholder="Select Origin Location"
                            labelInValue
                            disabled={activeTabName.includes('Pickup') && name === 0}
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormDatePicker
                            className="form-control form-control-sm"
                            name={[name, 'orgSpotDate']}
                            margin="m-0"
                            id="orgSpotDate"
                            disabled
                            onChange={(e) => handleDateForOrigin(e, 'orgSpotDate')}
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormDatePicker
                            disabled={name !== 0}
                            name={[name, 'orgETD']}
                            onChange={(e) => handleDateForOrigin(e, 'orgETD')}
                            margin="m-0"
                            id="orgETD"
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            type="text"
                            name={[name, 'orgSoftWeight']}
                            id="orgtxtSoftWeight"
                            editMode={editMode}
                            readOnly
                            onChange={(e) => handleFormChangeOrigin(e, 'orgSoftWeight')}
                            placeholder="Soft Weight"
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            editMode={editMode}
                            pattern="[0-9]*"
                            type="text"
                            name={[name, 'orgSoftOks']}
                            readOnly
                            id="orgtxtSoftOks"
                            placeholder="Soft OKs"
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            type="text"
                            name={[name, 'orgMiscWeight']}
                            id="orgtxtMiscWeight"
                            onChange={(e) => handleFormChangeOrigin(e, 'orgMiscWeight')}
                            editMode={editMode}
                            placeholder="Misc Weight"
                            readOnly
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            editMode={editMode}
                            type="text"
                            name={[name, 'orgMiscOks']}
                            readOnly
                            id="orgtxtMiscOks"
                            placeholder="Misc Oks"
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            editMode={editMode}
                            type="text"
                            name={[name, 'orgBookWeight']}
                            id="orgtxtBookWeight"
                            onChange={(e) => handleFormChangeOrigin(e, 'orgBookWeight')}
                            placeholder="Book Weight"
                            readOnly
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            editMode={editMode}
                            type="text"
                            name={[name, 'orgBookOks']}
                            readOnly
                            id="orgtxtBookOks"
                            placeholder="Book Oks"
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            editMode={editMode}
                            type="text"
                            name={[name, 'orgFurn']}
                            id="orgtxtFurn"
                            placeholder="Furn"
                            readOnly
                            onChange={(e) => handleFormChangeOrigin(e, 'orgFurn')}
                          />
                        </td>
                        <td className="center-align">
                          {/* biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            type="text"
                            editMode={editMode}
                            name={[name, 'orgOLI']}
                            id="orgtxtOLI"
                            placeholder="OLI"
                            readOnly
                            onChange={(e) => handleFormChangeOrigin(e, 'orgOLI')}
                          />
                        </td>
                        {fields.length > 1 && name !== 0 && (
                          <td className="center-align">
                            <Button
                              onClick={() => {
                                removeFromList('orgLocations', name);
                                remove(name);
                              }}
                              size="small"
                              type="default"
                              icon={<MinusOutlined />}
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Form.List>
      </Paper>
    </Col>
  );
};

export default OriginDetailsGrid;
